/* Login view */
import React from "react";
import { Formik, Field, Form } from "formik";
import { Link } from "react-router-dom";
import { Loading } from "seed/helpers";
import PasswordField from "components/util/helpers/fields/PasswordField";
import StyleColor from "components/util/helpers/StyleColor"
import l from "components/util/l";
import "styles/css/tmisc/Login.css";

const LoginView = ({
  flow,
  error,
  isLoading,
  onSubmit,
  onClickMicrosoftBtn,
  onClickGoogleBtn }) =>

  <div id="login" className="pl-0 h-100 w-100">
    {/* Apply flow theme colors if any */}
    <StyleColor theme={flow?.theme ?? {}} />

    <div class="container py-4 py-sm-6">
      <div class="d-flex justify-content-center mb-4 mb-md-5" href={"/"}>
        <div
          className={"z-index-2 pr-4 login-logo " +  (flow?.theme?.logo ? "custom " : " ")}
          alt="Logo"
          style={function () {
            let style = {}
            if (flow?.theme?.logo) style = { ...style, backgroundImage: `url(${flow.theme.logo})` }
            if (flow?.theme?.logoStyle) style = { ...style, ...flow.theme.logoStyle }
            return style
          }()}
        />
      </div>

      <div class="row justify-content-center">
        <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 px-2 px-md-3">
          <div className="card card-lg mb-5 pt-1 px-1 pb-2 animate__animated animate__fadeInUp animate__faster login-card">
            <div class="card-body px-4 px-sm-5">

              <Formik
                initialValues={{ rememberMe: true }}
                onSubmit={onSubmit}>
                {() =>
                  <Form>
                    <div class="text-center">
                      <div class="mb-4 mt-1">
                        <h1 class="display-4">{l("Iniciar sesión%VB011")}</h1>
                        {flow ? <div className="mt-n1">{flow.name}</div> : <div />
                        /* Temp hide 250911
                          <p>{l("¿Aún no tienes una cuenta?%VB045")} 
                          <Link to="/signup" className="ml-1">{l("Regístrate aquí%VB046")}</Link>
                        </p>*/ }
                      </div>
                    </div>

                    {/* Email */}
                    <div class="form-group">
                      <label class="input-label" for="formEmail">{l("Usuario%VB012")}</label>
                      <Field type="email" name="email" id="formEmail"
                        class="form-control form-control-lg" tabindex="1"
                        placeholder="email@address.com" maxlength="512"
                        required autofocus="1" 
                      />
                    </div>

                    {/* Password */}
                    <div class="form-group">
                      <label class="input-label" for="formPassword">
                        <span class="d-flex justify-content-between align-items-center">
                          {l("Contraseña%VB013")}
                          <Link class="input-label-secondary" to="/recover_password" tabindex="-1">
                            {l("¿Olvidaste tu contraseña?%VB016")}
                          </Link>
                        </span>
                      </label>

                      <PasswordField name="password" placeholder={l("Contraseña%VB013")} />
                    </div>

                    {/* Remember me */}
                    <div class="form-group">
                      <div class="custom-control custom-checkbox">
                        <Field id="formRememberMe" type="checkbox" name="rememberMe"
                          class="custom-control-input" tabindex="-1" />
                        <label class="custom-control-label text-muted" for="formRememberMe">
                          {l("Recordar cuenta%VB017")}
                        </label>
                      </div>
                    </div>

                    {/* Submit button */}
                    <button type="submit" class="btn btn-lg btn-block btn-accent" tabindex="1">
                      {l("Iniciar sesión%VB011")}
                    </button>

                    {error ?
                      <div className="alert alert-soft-danger text-center mt-2" role="alert">
                        {error}
                      </div> : null}

                    {/* Divider */}
                    <span className="divider text-muted mb-4 mt-4">O</span>

                    {/* Google and Microsoft Login Buttons */}
                    <div className="form-group mb-1">
                      <button type="button" className="btn btn-lg btn-microsoft btn-block btn-outline-secondary mb-2"
                        onClick={onClickMicrosoftBtn}>
                        <i className="fab fa-microsoft"></i>
                        {l("Iniciar sesión con Microsoft%VB014")}
                      </button>
                      <button type="button" className="btn btn-lg btn-google btn-block btn-outline-secondary"
                        onClick={onClickGoogleBtn}>
                        <i className="fab fa-google"></i>
                        {l("Iniciar sesión con Google%VB015")}
                      </button>
                    </div>

                  </Form>}
              </Formik>
            </div>
          </div>

          {/* General account redirect in case of custom flow login */}
          {flow && <a href="/logout" className="float-right px-1 mt-n3 login-workix-link">
            {l("Iniciar sesión con cuenta general de Workix%VB050")}
          </a>}

        </div>
      </div>

      {isLoading ? <div className="login-loading"><Loading /></div> : null}

    </div>

  </div>;

export default LoginView;